export default "https://cdn.questicon.mathletics.com/assets/audio/selfAssesmentEmojis_4-f7c0d6ffe35dac1c20de7b4af15242ec.mp3";